import { SET_GIFT_DETAILS_MUTATION } from './mutation.type'

export default {
    [SET_GIFT_DETAILS_MUTATION](state, gift) {
        state.giftDetails = gift;
    }
}